document.addEventListener('DOMContentLoaded', function () {
  var drawer = document.getElementById('mobile-drawer');
  if (!drawer) return;

  var overlay = document.getElementById('drawer-overlay');
  var closeBtn = document.getElementById('drawer-close');
  var hamburger = document.querySelector('.header__hamburger');

  if (!hamburger || !closeBtn || !overlay) return;

  function open() {
    drawer.setAttribute('aria-hidden', 'false');
    hamburger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    drawer.setAttribute('aria-hidden', 'true');
    hamburger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  hamburger.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    open();
  });

  closeBtn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();
    close();
  });

  overlay.addEventListener('click', function (e) {
    e.stopPropagation();
    close();
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') {
      close();
    }
  });

  // Close when clicking any navigation link inside the drawer
  drawer.querySelectorAll('a[href]').forEach(function (link) {
    link.addEventListener('click', function () {
      close();
    });
  });

  // Toggle sub-menus (level 2 and 3)
  drawer.querySelectorAll('.header__drawer-link--parent').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      var sub = btn.nextElementSibling;
      if (!sub) return;

      btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      sub.classList.toggle('header__drawer-sub--open', !expanded);
    });
  });
});
